import * as React from 'react';
import { List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { room } from '../../../model/room';
import TextField from '../../../ui-components/TextField/TextField';
import clsx from 'clsx';

interface IProps {
    rooms: Array<room>,
    selectRoom: (id: string) => void
    selected: string;
    handleBlur: (text: string, id: string) => any;
    handleChange: (text: string, id: string) => any;
    classes: any;
    filter: string;
    // edit: (room: room) => any;
    // edit: () => any;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IProps) => (
    // extends React.Component<IProps, IInternalState>
    <List>
        {props.rooms && props.rooms.filter(r =>
            props.filter ? (r.description.includes(props.filter) || r.code.includes(props.filter)) : true)
            .map((t, i) => {
                return (<div key={`1${i}`} style={{ width: "100%" }}>
                    <ListItem divider={true}
                        className={clsx(props.classes.room, { [props.classes.roomSelected]: props.selected === t._id })}
                        onClick={(e) => {
                            console.log(props.classes);
                            if (props.selected !== t._id) {
                                e.stopPropagation();
                                props.selectRoom(t._id);
                            }
                        }}>
                        <ListItemText primary={t.code} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block', width: 60, marginTop: 20 } }} />
                        <TextField label="Descrizione" value={t.description}
                            onBlur={(text) => props.handleBlur(text, t._id)}
                            onChange={(text) => props.handleChange(text, t._id)}
                        />
                    </ListItem>
                    <Divider />
                </div>);
            }
            )}
    </List>
);
